import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { Box, Collapse, Divider, Grid, Typography } from '@mui/material'
import MenuItem from '@mui/material/MenuItem'
import _ from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

/** TRANSLATION*/
import HeaderLabel from 'component/CardCustom/HeaderLabel'
import { useTranslation } from 'react-i18next'

/** STYLE */
import { colors } from 'constants/theme'
import useStyles, { ButtonAddBranch } from 'features/setting/personnel-managements/roles/style'

/** API */
import RolesApi, { RoleInterface, RolePermissionsInterface } from 'api/setting/personnel-managements/role.api'
import { routeName } from 'routes/routes-name'

/** UTILS || SLICE */
import { PACKAGE_ADDONS } from 'constants/package'
import { checkPackage, getClinicInfo, getPackageKey } from 'utils/app.utils'

/** COMPONENT */
import AboutUs from 'api/admin/clinic-manage/about.api'
import { swalWarning } from 'component/Alert/Swal'
import { ButtonDeleteSimple } from 'component/Button/ButtonDelete'
import Loading from 'component/Loading'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import BasicSelect from 'component/Select/BasicSelect'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import { Config } from 'config'
import CheckboxButton from 'new-components/buttons/checkbox-button'
import TextInput from 'new-components/inputs/text-input'

const initStateErrorMessage = {
  ROLE_NAME: '',
  IS_DUPLICATE_ROLE_NAME: '',
  ROLE_NAME_STRING_BASE: '',
  ROLE_NAME_STRING_EMPTY: '',
  ROLE_NAME_MAXIMUM_LENGTH: '',
  ROLE_NAME_ANY_REQUIRED: '',

  ROLE_NAME_EN: '',
  IS_DUPLICATE_ROLE_NAME_EN: '',
  ROLE_NAME_EN_STRING_BASE: '',
  ROLE_NAME_EN_STRING_EMPTY: '',
  ROLE_NAME_EN_MAXIMUM_LENGTH: '',
  ROLE_NAME_EN_ANY_REQUIRED: ''
}

const initRole = {
  branchId: 0,
  branchName: '',
  servicePointSelected: [],
  servicePoints: [],
  servicePointMenus: []
}

interface PermissionInterface {
  branchId?: number
  servicePointId?: number
  menuFirstId?: number
  menuSecondId?: number
  menuThirdId?: number
  name?: string
  view: boolean
  add: boolean
  edit: boolean
  del: boolean
  exp: boolean
}
interface ServicePointMenusInterface {
  servicePointId?: number
  menuTag: string
  permission: PermissionInterface[]
  menuSecondKey?: string
}

interface RoleRenderInterface {
  branchId: number
  branchName: string
  servicePointSelected: any[]
  servicePoints: any[]
  servicePointMenus: ServicePointMenusInterface[]
}
interface RolePermissionsRenderInterface {
  branchId: number
  branchName: string
  servicePointMenus: ServicePointMenusInterface[]
}

export default function RoleForm() {
  const { t } = useTranslation()
  const classes = useStyles()
  const history = useHistory()
  const location: any = useLocation()
  const package_role: any = getPackageKey()
  const clinic_info = getClinicInfo()

  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)
  const [initLocation, setInitLocation] = useState()

  /** DATA */
  const [branches, setBranches] = useState<any[]>([])

  /** FIELD */
  const [roleId, setRoleId] = useState<number | null>(null)
  const [roleName, setRoleName] = useState('')
  const [roleNameEn, setRoleNameEn] = useState('')
  const [roles, setRoles] = useState<RoleRenderInterface[]>([initRole])
  const [branchApp, setBranchApp] = useState<any>([])

  const role_standard = [
    // 'EXTRA',
    'MEDICINE',
    "INSTALLMENT",
    'REGISTER_APP',
    'LINE_NOTIFY',
    'EMAIL_NOTICE',
    'DOCTOR_NOTE',
    // 'RETROSPECTIVE_ORDER',
    // 'RETROSPECTIVE_EDIT',
    'SALARY',
    // 'ADVANCE',
    'TREATMENT_PLAN_MANAGE',
    'TREATMENT_PLAN_TYPE',
    'TREATMENT_PLAN',
    'TREATMENT_COURSE_MANAGE',
    'TREATMENT_COURSE_TYPE',
    'TREATMENT_COURSE',
    'INCOME_EXPENSES',
    'DOCTOR_NOTE_TYPE_FORM',
    'DOCTOR_NOTE_FORM',
    'DOCTOR_NOTE_TYPE_PIC',
    'DOCTOR_NOTE_PIC',
    'RECALL',
    'RECALL_LISTS',
    'WAREHOUSES',
    'DEFAULT_PRODUCT',
    'APPLICATION_NOTICE',
    'DASHBOARD',
    'PROMOTIONS',
    'NEWS',
    'USAGE_APPROVAL_MANAGEMENT',
    'LAB',
    'LAB_MANAGEMENT',
    'LAB_LIST',
    'LAB_TYPE',
    'LAB_GROUP',
    'LAB_COMPANY',
    'X_RAY',
    'XRAY_FILM_TYPE',
    // 'IMAGE_TYPE',
    'APPROVAL',
    'APPROVELIST',
    'MESSAGE_NOTIFICATION',
    "PRODUCT",
    "IMPORT_PRODUCT",
    "INVENTORY_LIST",
    "ADJUSTMENT",
    "MATERIAL",
    "CURRENCY",
  ]

  const role_premium = [
    "INSTALLMENT",
    'APPLICATION_NOTICE',
    "REGISTER_APP",
    "APPLICATION",
    'DASHBOARD',
    'PROMOTIONS',
    'NEWS',
    'USAGE_APPROVAL_MANAGEMENT',
    // 'LAB',
    // 'LAB_MANAGEMENT',
    // 'LAB_LIST',
    // 'LAB_TYPE',
    // 'LAB_GROUP',
    // 'LAB_COMPANY',
    // 'X_RAY',
    // 'XRAY_FILM_TYPE',
    // 'IMAGE_TYPE',
    'APPROVAL',
    'APPROVELIST',
    "CURRENCY"
  ]
  const role_ultra = ["INSTALLMENT", "REGISTER_APP", "MESSAGE_NOTIFICATION", "CURRENCY", 'PROMOTIONS', 'NEWS']

  const crmAddOn = ["PROMOTION_TYPE", "PROMOTION", "VOUCHER_TYPE", "VOUCHER", "MEMBER_MANAGEMENT"]
  const webAddOn = ["WEB_MANAGE", "BANNER", "ABOUT_US", "PRICE_LIST", "REVIEW", "ARTICLE", "CONTACT_US", "SERVICE"]
  const TDHAddOn = ["CHECKIN"]
  const appAddOn = ['REGISTER_APP', "MESSAGE_NOTIFICATION"]
  if (package_role === 'STANDARD') {
    if (clinic_info?.isUseCrm === '0' && clinic_info?.isUseWeb === '0' && Config.IS_TDH === '0') {
      role_standard.unshift('EXTRA')
    }
  }

  if (package_role === 'ULTRA') {
    if (clinic_info?.enableApp === '1') {
      appAddOn.push('PROMOTIONS')
      appAddOn.push('NEWS')
    }
  }

  const loadDataBranch = useCallback(() => {
    RolesApi.findAllBranch().then(({ data }) => setBranches(data))
  }, [])


  type RawMenu = {
    menuFirstSorting: number
    menuFirstKey: string
    menuSecondSorting: number | null
    menuSecondKey?: string
    menuThirdKey?: string
    [k: string]: any
  }

  /**
   * กรุ๊ปตาม menuFirstKey
   * แล้วจัดเรียง
   *  1) menuFirstSorting
   *  2) menuFirstKey
   *  3) null-second ก่อน
   *  4) menuSecondSorting
   */
  function groupAndSortMenus(menus: RawMenu[]): RawMenu[] {
    const grouped = Object.values(
      menus
        .sort((a, b) => {
          const d1 = a.menuFirstSorting - b.menuFirstSorting
          if (d1) return d1
          const d2 = a.menuFirstKey.localeCompare(b.menuFirstKey)
          if (d2) return d2
          return 0
        })
        .reduce((acc: Record<string, RawMenu[]>, m) => {
          (acc[m.menuFirstKey] = acc[m.menuFirstKey] || []).push(m)
          return acc
        }, {})
    )

    const sortedGroup = grouped.sort((a, b) => {
      const sortA = a[0]?.menuFirstSorting ?? 0;
      const sortB = b[0]?.menuFirstSorting ?? 0;
      return sortA - sortB;
    });

    const newSortedGroup = sortedGroup.map(group =>
      [...group].sort((a, b) => {
        if (a.menuSecondSorting === null && b.menuSecondSorting !== null) return -1
        if (a.menuSecondSorting !== null && b.menuSecondSorting === null) return 1
        return (a.menuSecondSorting ?? 0) - (b.menuSecondSorting ?? 0)
      })
    )
    return newSortedGroup.flat()
  }


  const loadDataMenu = (iRole: number, servicePointId = '') => {
    RolesApi.findAllServicePointMenu({ servicePointId: servicePointId }).then(({ data }: any) => {
      const sp = data[0]
      // 
      const filterRoles = package_role === 'STANDARD' ? role_standard : package_role === 'PREMIUM' ? role_premium : role_ultra
      // ⭐️ filter ก่อน

      let filteredMenus = sp.servicePointMenus.filter((spm: any) => {
        return !(
          filterRoles.includes(spm.menuThirdKey) ||
          filterRoles.includes(spm.menuSecondKey) ||
          filterRoles.includes(spm.menuFirstKey)
        )
      })

      if (package_role !== 'STANDARD') {
        if (clinic_info.enableApp === '1') {
          const appMenus = sp?.servicePointMenus.filter((spm: any) => {
            return (
              appAddOn.includes(spm.menuThirdKey?.toUpperCase())
            )
          })
          filteredMenus = [...filteredMenus, ...appMenus]
        }
      }

      // ⭐️ แยกเมนู crmFilter ออกมา
      const crmMenus = sp.servicePointMenus.filter((spm: any) => {
        return (
          crmAddOn.includes(spm.menuThirdKey?.toUpperCase())
        )
      })

      // ⭐️ เอาเมนูที่ไม่ใช่ crmFilter ไว้ใน filteredMenus
      filteredMenus = filteredMenus.filter((spm: any) => {
        return !(
          crmAddOn.includes(spm.menuThirdKey?.toUpperCase()) ||
          crmAddOn.includes(spm.menuSecondKey?.toUpperCase()) ||
          crmAddOn.includes(spm.menuFirstKey?.toUpperCase())
        )
      })
      // ⭐️ ถ้า clinic_info?.isUseCrm === '1' เพิ่ม crmMenus กลับเข้าไป
      if (clinic_info?.isUseCrm === '1') {
        filteredMenus = [...filteredMenus, ...crmMenus]
      }

      const webMenus = sp.servicePointMenus.filter((spm: any) => {
        return (
          webAddOn.includes(spm.menuThirdKey?.toUpperCase()) ||
          webAddOn.includes(spm.menuSecondKey?.toUpperCase()) ||
          webAddOn.includes(spm.menuFirstKey?.toUpperCase())
        )
      })

      filteredMenus = filteredMenus.filter((spm: any) => {
        return !(
          webAddOn.includes(spm.menuThirdKey?.toUpperCase()) ||
          webAddOn.includes(spm.menuSecondKey?.toUpperCase()) ||
          webAddOn.includes(spm.menuFirstKey?.toUpperCase())
        )
      })

      if (clinic_info?.isUseWeb === '1') {
        filteredMenus = [...filteredMenus, ...webMenus]
      }

      if (Config.IS_TDH === '0') {
        filteredMenus = filteredMenus.filter((spm: any) => {
          return !(
            TDHAddOn.includes(spm.menuSecondKey?.toUpperCase())
          )
        })
      }


      const sorted = groupAndSortMenus(filteredMenus)
      const newServicePointMenu: ServicePointMenusInterface = {
        servicePointId: sp.servicePointId,
        menuTag: sp.servicePointName,
        permission: sorted.map((spm: any) => ({
          branchId: roles[iRole]?.branchId,
          servicePointId: sp.servicePointId,
          menuFirstId: spm.menuFirstId || 0,
          menuSecondId: spm.menuSecondId || 0,
          menuThirdId: spm.menuThirdId || 0,
          name: spm.menuThirdKey || spm.menuSecondKey || spm.menuFirstKey || '',
          view: false,
          add: false,
          edit: false,
          del: false,
          exp: false
        }))
      }

      const pRoles: any = _.merge([], roles)
      pRoles[iRole].servicePointMenus = [...pRoles[iRole].servicePointMenus, newServicePointMenu]
      setRoles(pRoles)
    })
  }

  const discardServicePoint = (servicePoint: { value: number, label: string }[], iRole: number) => {
    let newServicePointMenu: any = []
    _.forEach(servicePoint, (sp) => {
      newServicePointMenu = [...newServicePointMenu, _.find(roles[iRole].servicePointMenus, { servicePointId: sp.value })]
    })
    const pRoles: any = _.merge([], roles)
    pRoles[iRole].servicePointMenus = newServicePointMenu
    setRoles(pRoles)
  }

  const handleCheckApp = (branchId: number) => {
    if (branchApp?.length) {
      return branchApp.some((item: any) => item.branchId === branchId && item?.isDefaultRegisApp === '1')
    }
    return true
  }

  const loadAboutUs = async () => {
    const res = await AboutUs.findAboutUs()
    if (res.status === 200 && res.data?.branchDefaultRegisterApps?.length) {
      setBranchApp(res.data.branchDefaultRegisterApps)
    }
  }

  useEffect(() => {
    loadAboutUs()
  }, [])

  useEffect(() => {
    setRoles([])
    loadDataBranch()
  }, [loadDataBranch])

  useEffect(() => {
    if (!initLocation) setInitLocation(location)
    if (branches.length) {
      const { state }: any = location
      if (state?.roleId) {
        onEdit()
      }
    }
  }, [branches, location])

  const onEdit = async () => {
    const { state }: any = location
    if (state?.roleId) {
      setRoleId(state.roleId)
      setLoading(true)
      if (state.roleId) {
        RolesApi.findById(state.roleId).then(({ data }) => {
          if (data?.roleId) setRoleId(data?.roleId)
          setRoleName(data?.roleName)
          setRoleNameEn(data?.roleNameEn)

          if (data?.roleBranches?.length) {
            const arrBranches: any = _.groupBy(data?.rolePermissions, 'branchId')

            const temp: any[] = _.map(arrBranches, (b: any, iRp: number) => {
              const findBranch: any = data?.roleBranches.find((branch: any) => branch.branchId === b[0]?.branchId)
              const arrServicePoints: any = _.groupBy(b, 'servicePointId')

              const findb = _.get(_.find(branches, (branch: any, i: any) => branch.branchId === b[0]?.branchId), 'branchServicePoints') || []
              const servicePoint = _.filter(data?.roleBranches, (branch: any, i: any) => branch.branchId === b[0]?.branchId).map((bsp: any) => ({ value: bsp.servicePointId, label: bsp?.servicePoints?.servicePointName || '' })) || []

              const servicePointSelected = _.filter(servicePoint, (element) => {
                return _.some(findb, (findbItem) => {
                  return findbItem.servicePointId === element.value;
                });
              });
              return {
                branchId: findBranch?.branches?.branchId || 0,
                branchName: findBranch?.branches?.branchName || '',
                servicePoints: findBranch?.branchServicePoints || [],
                servicePointSelected: servicePointSelected || _.filter(data?.roleBranches, (branch: any, i: any) => branch.branchId === b[0]?.branchId).map((bsp: any) => ({ value: bsp.servicePointId, label: bsp?.servicePoints?.servicePointName || '' })) || [],
                servicePointMenus: _.map(arrServicePoints, (s: any) => {
                  const findServicePoint: any = data?.roleBranches.find((sp: any) => sp.servicePointId === s[0].servicePointId)
                  const filterRoles = package_role === 'STANDARD' ? role_standard : package_role === 'PREMIUM' ? role_premium : role_ultra
                  let filteredMenus = s.filter((spm: any) => {
                    return !(
                      filterRoles.includes(spm.menuThirdKey) ||
                      filterRoles.includes(spm.menuSecondKey) ||
                      filterRoles.includes(spm.menuFirstKey)
                    )
                  })
                  if (package_role !== 'STANDARD') {
                    if (clinic_info.enableApp === '1') {
                      const appMenus = s.filter((spm: any) => {
                        return (
                          appAddOn.includes(spm.menuThirdKey?.toUpperCase())
                        )
                      })
                      filteredMenus = [...filteredMenus, ...appMenus]
                    }
                  }

                  const crmMenus = s.filter((spm: any) => {
                    return (
                      crmAddOn.includes(spm.menuThirdKey?.toUpperCase())
                    )
                  })
                  filteredMenus = filteredMenus.filter((spm: any) => {
                    return !(
                      crmAddOn.includes(spm.menuThirdKey?.toUpperCase()) ||
                      crmAddOn.includes(spm.menuSecondKey?.toUpperCase()) ||
                      crmAddOn.includes(spm.menuFirstKey?.toUpperCase())
                    )
                  })
                  if (clinic_info?.isUseCrm === '1') {
                    filteredMenus = [...filteredMenus, ...crmMenus]
                  }
                  const webMenus = s.filter((spm: any) => {
                    return (
                      webAddOn.includes(spm.menuThirdKey?.toUpperCase()) ||
                      webAddOn.includes(spm.menuSecondKey?.toUpperCase()) ||
                      webAddOn.includes(spm.menuFirstKey?.toUpperCase())
                    )
                  })
                  filteredMenus = filteredMenus.filter((spm: any) => {
                    return !(
                      webAddOn.includes(spm.menuThirdKey?.toUpperCase()) ||
                      webAddOn.includes(spm.menuSecondKey?.toUpperCase()) ||
                      webAddOn.includes(spm.menuFirstKey?.toUpperCase())
                    )
                  })
                  if (clinic_info?.isUseWeb === '1') {
                    filteredMenus = [...filteredMenus, ...webMenus]
                  }
                  if (Config.IS_TDH === '0') {
                    filteredMenus = filteredMenus.filter((spm: any) => {
                      return !(
                        TDHAddOn.includes(spm.menuSecondKey?.toUpperCase())
                      )
                    })
                  }


                  const sorted = groupAndSortMenus(filteredMenus)
                  return {
                    servicePointId: findServicePoint?.servicePoints?.servicePointId,
                    menuTag: findServicePoint?.servicePoints?.servicePointName || '',
                    permission: sorted.map(spm => ({
                      branchId: findBranch.branchId,
                      servicePointId: findServicePoint?.servicePoints?.servicePointId,
                      menuFirstId: spm?.menuFirstId || 0,
                      menuSecondId: spm?.menuSecondId || 0,
                      menuSecondKey: spm?.menuSecondKey || '',
                      menuThirdId: spm?.menuThirdId || 0,
                      name: spm?.menuThirdKey || spm?.menuSecondKey || spm?.menuFirstKey || '',
                      view: spm?.isView === 1 ? true : false,
                      add: spm?.isCreate === 1 ? true : false,
                      edit: spm?.isUpdate === 1 ? true : false,
                      del: spm?.isDelete === 1 ? true : false,
                      exp: spm?.isExport === 1 ? true : false
                    }))
                  }
                })
              }
            })

            for (let iRole = 0; iRole < temp.length; iRole++) {
              const element = temp[iRole];
              let servicePointId: any = _.filter(data?.roleBranches, (branch: any, i: any) => branch.branchId === element?.branchId).map((bsp: any) => { return bsp.servicePointId }).join(',')
              RolesApi.findAllServicePointMenu({ servicePointId: servicePointId }).then(({ data }) => {
                const servicePoints: any = data
                servicePointId = servicePointId.split(",");
                const servicePointsOption = _.get(_.find(branches, (branch: any, i: any) => branch.branchId === element?.branchId), 'branchServicePoints') || []

                const servicePointSelected = _.filter(servicePoints, (element) => {
                  return _.some(servicePointsOption, (findbItem) => {
                    return findbItem.servicePointId === element.servicePointId;
                  });
                });

                temp[iRole].servicePoints = servicePointsOption
                temp[iRole].servicePointMenus = _.map(servicePointSelected, (servicePoint: any) => {
                  const findServicePoint: any = element.servicePointMenus.find((sp: any) => Number(sp.servicePointId) === Number(servicePoint.servicePointId))
                  const filterRoles = package_role === 'STANDARD' ? role_standard : package_role === 'PREMIUM' ? role_premium : role_ultra
                  let filteredMenus = servicePoint?.servicePointMenus.filter((spm: any) => {
                    return !(
                      filterRoles.includes(spm.menuThirdKey) ||
                      filterRoles.includes(spm.menuSecondKey) ||
                      filterRoles.includes(spm.menuFirstKey)
                    )
                  })

                  if (package_role !== 'STANDARD') {
                    if (clinic_info.enableApp === '1') {
                      const appMenus = servicePoint?.servicePointMenus.filter((spm: any) => {
                        return (
                          appAddOn.includes(spm.menuThirdKey?.toUpperCase())
                        )
                      })
                      filteredMenus = [...filteredMenus, ...appMenus]
                    }
                  }

                  const crmMenus = servicePoint?.servicePointMenus.filter((spm: any) => {
                    return (
                      crmAddOn.includes(spm.menuThirdKey?.toUpperCase())
                    )
                  })
                  filteredMenus = filteredMenus.filter((spm: any) => {
                    return !(
                      crmAddOn.includes(spm.menuThirdKey?.toUpperCase()) ||
                      crmAddOn.includes(spm.menuSecondKey?.toUpperCase()) ||
                      crmAddOn.includes(spm.menuFirstKey?.toUpperCase())
                    )
                  })
                  if (clinic_info?.isUseCrm === '1') {
                    filteredMenus = [...filteredMenus, ...crmMenus]
                  }
                  const webMenus = servicePoint?.servicePointMenus.filter((spm: any) => {
                    return (
                      webAddOn.includes(spm.menuThirdKey?.toUpperCase()) ||
                      webAddOn.includes(spm.menuSecondKey?.toUpperCase()) ||
                      webAddOn.includes(spm.menuFirstKey?.toUpperCase())
                    )
                  })
                  filteredMenus = filteredMenus.filter((spm: any) => {
                    return !(
                      webAddOn.includes(spm.menuThirdKey?.toUpperCase()) ||
                      webAddOn.includes(spm.menuSecondKey?.toUpperCase()) ||
                      webAddOn.includes(spm.menuFirstKey?.toUpperCase())
                    )
                  })
                  if (clinic_info?.isUseWeb === '1') {
                    filteredMenus = [...filteredMenus, ...webMenus]
                  }
                  if (Config.IS_TDH === '0') {
                    filteredMenus = filteredMenus.filter((spm: any) => {
                      return !(
                        TDHAddOn.includes(spm.menuSecondKey?.toUpperCase())
                      )
                    })
                  }

                  const sorted = groupAndSortMenus(filteredMenus)
                  return {
                    servicePointId: servicePoint.servicePointId,
                    menuTag: servicePoint.servicePointName || '',
                    permission: sorted.map((spm: any) => {
                      // _.map(_.sortBy(filteredMenus, ['menuFirstSorting', 'menuFirstKey']), (spm) => {
                      const findPermission = _.find(findServicePoint?.permission, (sp) => sp.servicePointId === spm.servicePointId && sp.menuFirstId === spm.menuFirstId && sp.menuSecondId === (spm?.menuSecondId || 0) && sp.menuThirdId === (spm?.menuThirdId || 0))
                      return {
                        branchId: temp[iRole].branchId,
                        servicePointId: servicePoint.servicePointId,
                        menuFirstId: spm?.menuFirstId || 0,
                        menuSecondId: spm?.menuSecondId || 0,
                        menuSecondKey: spm?.menuSecondKey || '',
                        menuThirdId: spm?.menuThirdId || 0,
                        name: spm?.menuThirdKey || spm?.menuSecondKey || spm?.menuFirstKey || '',
                        view: findPermission?.view ? true : false,
                        add: findPermission?.add ? true : false,
                        edit: findPermission?.edit ? true : false,
                        del: findPermission?.del ? true : false,
                        exp: findPermission?.exp ? true : false
                      }
                    })
                  }
                })
                setRoles([...temp])
              })
            }
          }
        }).finally(() => setLoading(false))
      }
    }

  }

  const getRolePermissions = () => {
    const rolePermissionsSave: RolePermissionsInterface[] = []
    for (const iRole in roles) {
      if (Object.prototype.hasOwnProperty.call(roles, iRole)) {
        const { branchId, servicePointMenus } = roles[iRole]
        for (const iServicePointMenu in servicePointMenus) {
          if (Object.prototype.hasOwnProperty.call(servicePointMenus, iServicePointMenu)) {
            const { servicePointId, permission } = servicePointMenus[iServicePointMenu]
            const permissions: PermissionInterface[] = permission.filter(({ view, add, edit, del, exp }: any) => view === true || add === true || edit === true || del === true || exp === true)
            for (const iPermission in permissions) {
              if (Object.prototype.hasOwnProperty.call(permissions, iPermission)) {
                const pms: any = permissions[iPermission]
                rolePermissionsSave.push({
                  branchId: branchId,
                  servicePointId: Number(servicePointId),
                  menuFirstId: pms.menuFirstId,
                  menuSecondId: pms.menuSecondId,
                  menuThirdId: pms.menuThirdId,
                  isView: pms.view ? 1 : 0,
                  isCreate: pms.add ? 1 : 0,
                  isUpdate: pms.edit ? 1 : 0,
                  isDelete: pms.del ? 1 : 0,
                  isExport: pms.exp ? 1 : 0
                })
              }
            }
          }
        }
      }
    }
    return rolePermissionsSave
  }

  const submit = async () => {
    if (!roleName) return setErrorMessage({ ...errorMessage, ...{ ROLE_NAME: !roleName ? t('ROLE.MESSAGE.ROLE_NAME') : '' } })
    if (_.some(roles, (r) => _.some(r.servicePointMenus, (rs) => _.every(rs.permission, { view: false, add: false, edit: false, del: false, exp: false })))) return notiError(t('POSITION.MESSAGE.PERSONNEL_NOTI'))
    const permissionsSave = getRolePermissions()
    if (_.isEmpty(permissionsSave)) return notiError(t('ROLE.MESSAGE.AT_LEAST_ONE_PERMISSION_REQUIRED'))
    const roleSave: RoleInterface = {
      roleName: roleName,
      roleNameEn: roleNameEn,
      rolePermissions: permissionsSave
    }

    if (!roleId) create(roleSave)
    else {
      roleSave.status = 'ACTIVE'
      update(roleSave)
    }
  }

  const create = (roleSave: RoleInterface) => {
    setLoading(true)
    RolesApi.create(roleSave)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t(`ROLE.MESSAGE.SUCCESS.CREATE`), '', null, () => {

            return
          })
          history.push(routeName.roles)
        }
        else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`ROLE.MESSAGE.${err.message}`) } })
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`ROLE.MESSAGE.${err.message}`) } })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const update = (roleSave: RoleInterface) => {
    swalWarning(
      `<p class="mb-0 mx-auto" style="max-width: 325px">${t('ROLE.MESSAGE.POPUP_UPDATE.TITLE')}</p>`,
      `<p class="mb-0 mx-auto" style="max-width: 370px">${t('ROLE.MESSAGE.POPUP_UPDATE.SUBTITLE')}</p>`,
      () => {
        setLoading(true)
        RolesApi.update(Number(roleId), roleSave)
          .then((res: any) => {
            if (res.status !== undefined && res.status === 200) {
              notiSuccess(t(`ROLE.MESSAGE.SUCCESS.UPDATE`), '', null, () => {
                return
              })
              history.push(routeName.roles)
            }
            else {
              const err = res.response?.data
              setErrorMessage({ ...errorMessage, ...{ [err?.message]: t(`ROLE.MESSAGE.${err?.message}`) } })
            }
          })
          .catch((e) => {
            const err = e.response?.data
            setErrorMessage({ ...errorMessage, ...{ [err?.message]: t(`ROLE.MESSAGE.${err?.message}`) } })
          })
          .finally(() => {
            setLoading(false)
          })
      }, { allowOutsideClick: false, showCancelButton: true })
  }

  const selectAllPermission = (iServicePoint: any, key: any, value: any, iRole: any) => {
    const role = roles[iRole]
    roles[iRole].servicePointMenus = role.servicePointMenus.map((menu: any, index_service_select: any) => {
      if (index_service_select === iServicePoint)
        return {
          ...menu,
          permission: menu.permission.map((per: any) => { return { ...per, [key]: value } })
        }
      else return menu
    })
    setRoles([...roles])
  }

  const selectPermission = (iRole: any, iServicePoint: any, name: any, key: any, value: any, iPermission: number) => {
    const role: any = roles[iRole]
    role.servicePointMenus[iServicePoint].permission[iPermission][key] = value
    roles[iRole] = role
    setRoles([...roles])
  }

  const handleChangeServicePoint = (role: RoleRenderInterface, iRole: number, reason: string) => {
    const serviceSelect = role?.servicePointSelected
    if (reason === 'selectOption') loadDataMenu(iRole, _.last(serviceSelect)?.value)
    else discardServicePoint(serviceSelect, iRole)
  }

  return (
    <Box sx={{ background: '#ffffff 0% 0% no-repeat padding-box !important', boxShadow: '0px 3px 6px #0000001a !important', border: '1px solid #e5e5e5 !important', height: '100%', backgroundColor: colors.white }}>
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Loading show={loading} type="fullLoading" />
        <HeaderLabel
          text={roleId ? t('ROLE.TITLE_UPDATE') : t('ROLE.TITLE_CREATE')}
          navigator={{ previousTo: routeName.roles, previousTitle: t('ROLE.TITLE'), currentTitle: roleId ? t('ROLE.TITLE_UPDATE') : t('ROLE.TITLE_CREATE') }}
          goBack={routeName.roles}
          onSubmit={submit}
        />
        <Box sx={{ background: '#ffffff 0% 0% no-repeat padding-box', boxShadow: '0px 3px 6px #0000001a', border: '1px solid #e5e5e5', mx: '24px', mb: '24px', height: '100%', overflow: 'hidden', borderRadius: '8px' }}>
          <Box sx={{ height: '100vh', overflow: 'hidden', p: '16px' }}>
            <Box sx={{ width: '100%', height: 'calc(100vh - 30vh)', overflowY: 'auto', overflowX: 'hidden' }}>
              <Grid container spacing={2} sx={{ mx: 0 }}>
                <Grid item sm={4} xs={12} sx={{ mt: 2, px: 1 }}>
                  <TextInput
                    required
                    label={t('ROLE.TABLE.CELL.ROLE_NAME')}
                    value={roleName}
                    onChange={e => {
                      setRoleName(e.target.value)
                      setErrorMessage(initStateErrorMessage)
                    }}
                    helperText={
                      errorMessage.ROLE_NAME ||
                      errorMessage.IS_DUPLICATE_ROLE_NAME ||
                      errorMessage.ROLE_NAME_STRING_BASE ||
                      errorMessage.ROLE_NAME_STRING_EMPTY ||
                      errorMessage.ROLE_NAME_MAXIMUM_LENGTH ||
                      errorMessage.ROLE_NAME_ANY_REQUIRED
                    }
                    fullWidth
                  />
                </Grid>
                <Grid item sm={4} xs={12} sx={{ mt: 2, px: 1 }}>
                  <TextInput
                    label={t('ROLE.TABLE.CELL.ROLE_NAME_EN')}
                    value={roleNameEn}
                    helperText={
                      errorMessage.ROLE_NAME_EN ||
                      errorMessage.IS_DUPLICATE_ROLE_NAME_EN ||
                      errorMessage.ROLE_NAME_EN_STRING_BASE ||
                      errorMessage.ROLE_NAME_EN_STRING_EMPTY ||
                      errorMessage.ROLE_NAME_EN_MAXIMUM_LENGTH ||
                      errorMessage.ROLE_NAME_EN_ANY_REQUIRED
                    }
                    onChange={e => {
                      setRoleNameEn(e.target.value)
                      setErrorMessage(initStateErrorMessage)
                    }}
                    fullWidth
                  />
                </Grid>
              </Grid>
              {roles.map((role, iRole) => (
                <Grid container spacing={2} key={iRole} sx={{ mx: 0 }}>
                  <Grid item sm={4} xs={12} sx={{ mt: 2, px: 1 }}>
                    <BasicSelect
                      onchange={event => {
                        const value = event.target.value
                        if (value) {
                          const {
                            branchId: id,
                            branchName: name,
                            branchServicePoints
                          } = branches.find(b => b.branchId === value)
                          role.branchId = id
                          role.branchName = name
                          role.servicePoints = branchServicePoints
                          role.servicePointSelected = []
                          role.servicePointMenus = []
                          setRoles([...roles])
                        }
                      }}
                      label={t('ROLE.BRANCH')}
                      selectId="branch"
                      value={role.branchId}
                      labelId="branch"
                      options={branches.map(({ branchId, branchName }) => (
                        <MenuItem
                          key={branchId}
                          value={branchId}
                          sx={{
                            pointerEvents: _.some(roles, { branchId })
                              ? 'none'
                              : 'auto',
                            opacity: _.some(roles, { branchId }) ? 0.5 : 1
                          }}
                        >
                          {branchName}
                        </MenuItem>
                      ))}
                    />
                  </Grid>
                  <Grid item sm={7} xs={11} sx={{ mt: 2, px: 1 }}>
                    {branches && (
                      <AutocompleteSelect
                        disableClearable
                        multiple
                        labelId="servicepoint-id"
                        inputLabel={t('ROLE.SERVICE_POINT')}
                        noOptionsText={t('ROLE.NO_SERVICE_POINTS_FOUND')}
                        options={
                          role.servicePoints.map(sp => ({
                            value: sp.servicePointId,
                            label: sp.servicePointName || ''
                          })) || []
                        }
                        getOptionLabel={option => option.label}
                        value={role.servicePointSelected}
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            {...props}
                            sx={{
                              pointerEvents: _.some(
                                role.servicePointSelected,
                                { value: option.value }
                              )
                                ? 'none !important'
                                : 'auto !important',
                              opacity: _.some(
                                role.servicePointSelected,
                                { value: option.value }
                              )
                                ? 0.5
                                : 1
                            }}
                          >
                            {option.label}
                          </Box>
                        )}
                        onchange={(e, value, reason) => {
                          role.servicePointSelected = value
                          setRoles([...roles])
                          handleChangeServicePoint(role, iRole, reason)
                        }}
                      />
                    )}
                  </Grid>
                  <Grid item sm={1} xs={1}
                    sx={{
                      mt: 2, px: 1,
                      display: 'flex',
                      alignItems: 'center',
                      filter: roles.length <= 1 ? 'grayscale(1)' : 'none',
                      opacity: roles.length <= 1 ? 0.6 : 1,
                      pointerEvents: roles.length <= 1 ? 'none' : 'auto'
                    }}
                  >
                    <ButtonDeleteSimple
                      disabled={roles.length <= 1}
                      onClick={() =>
                        setRoles(roles.filter((_, idx) => idx !== iRole))
                      }
                    />
                  </Grid>
                </Grid>
              ))}
              <Box sx={{ mt: 2, mx: 1, justifyContent: 'flex-start' }}>
                <ButtonAddBranch
                  disabled={
                    roles.length === branches.length ||
                    _.some(roles, role => !role.branchId)
                  }
                  sx={{ width: 'auto', px: 1 }}
                  onClick={() => setRoles([...roles, { ...initRole, branchId: 0 }])}
                >
                  + {t('ROLE.ADD_BRANCH')}
                </ButtonAddBranch>
              </Box>
              <Divider sx={{ mx: 0, my: 2, backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
              {roles.map((role, iRole) => (
                <Box mx="3px" key={iRole}>
                  <RoleFormBranch
                    key={iRole}
                    roles={roles}
                    role={role}
                    iRole={iRole}
                    selectAllPermission={selectAllPermission}
                    handleCheckApp={handleCheckApp}
                    selectPermission={selectPermission}
                  />
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

type RoleFormBranchProps = {
  roles: RoleRenderInterface[]
  role: RoleRenderInterface
  iRole: number
  selectAllPermission: (iServicePoint: any, key: any, value: any, iRole: any) => void
  handleCheckApp: (branchId: number) => void
  selectPermission: (iRole: any, iServicePoint: any, name: any, key: any, value: any, iPermission: number) => void
}

const RoleFormBranch = (props: RoleFormBranchProps) => {
  const { roles, role, iRole, selectAllPermission, handleCheckApp, selectPermission } = props
  const { t } = useTranslation()
  const classes = useStyles()
  const menuHidden = ['SMART_CARD', 'ADJUSTMENT_PRODUCT', 'CLINIC_MANAGEMENT']

  const [openBranch, setOpenBranch] = useState<boolean>(false)
  const [display, setDisplay]: any = useState({})
  const [permissonSelect, setPermissonSelect] = useState<any>([])
  const [iServicePointSelect, setIServicePointSelect] = useState<number>(0)

  useEffect(() => {
    if (roles[iRole]?.branchId) {
      if (!permissonSelect?.length) {
        setPermissonSelect(roles[iRole].servicePointMenus[0]?.permission || [])
      } else {
        setPermissonSelect(roles[iRole]?.servicePointMenus[iServicePointSelect]?.permission || [])
      }
    }
  }, [roles])


  const renderRole = () => {
    const view_all = permissonSelect.filter(({ view }: any) => view === true)
    const add_all = permissonSelect.filter(({ add }: any) => add === true)
    const edit_all = permissonSelect.filter(({ edit }: any) => edit === true)
    const del_all = permissonSelect.filter(({ del }: any) => del === true)
    const exp_all = permissonSelect.filter(({ exp }: any) => exp === true)
    const permission = permissonSelect
    // const permission = permissonSelect.sort((a: any, b: any) => {
    //   if (a.menuFirstId !== b.menuFirstId) {
    //     return a.menuFirstId - b.menuFirstId;
    //   }
    //   if (a.menuSecondId === 0 && b.menuSecondId !== 0) return -1;
    //   if (a.menuSecondId !== 0 && b.menuSecondId === 0) return 1;
    //   if (a.menuSecondId !== b.menuSecondId) {
    //     return a.menuSecondId - b.menuSecondId;
    //   }
    //   return a.menuThirdId - b.menuThirdId;
    // });

    return (
      <Box>
        <Grid container sx={{ mt: 2, pl: 3, pt: 1, pb: 1 }} >
          <Grid item xs={12} sm={2} sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography sx={{ fontWeight: 600, color: colors.themeMainColor }}>{t('ROLE.PERMISSION_IN_SERVICE_POINT')}</Typography>
          </Grid>
          {[
            { key: 'view', label: t('ROLE.LIST_VIEW'), checked: view_all.length === permission.length, onChange: (e: any) => selectAllPermission(iServicePointSelect, 'view', e.target.checked, iRole) },
            { key: 'add', label: t('ROLE.LIST_ADD'), checked: add_all.length === permission.length, onChange: (e: any) => selectAllPermission(iServicePointSelect, 'add', e.target.checked, iRole) },
            { key: 'edit', label: t('ROLE.LIST_EDIT'), checked: edit_all.length === permission.length, onChange: (e: any) => selectAllPermission(iServicePointSelect, 'edit', e.target.checked, iRole) },
            { key: 'del', label: t('ROLE.LIST_DELETE'), checked: del_all.length === permission.length, onChange: (e: any) => selectAllPermission(iServicePointSelect, 'del', e.target.checked, iRole) },
            { key: 'exp', label: t('ROLE.LIST_EXPORT'), checked: exp_all.length === permission.length, onChange: (e: any) => selectAllPermission(iServicePointSelect, 'exp', e.target.checked, iRole) },
          ].map(({ key, label, checked, onChange }) => (
            <Grid item xs={2} sm={2} key={key}><CheckboxButton label={label} checked={checked} onChange={onChange} /></Grid>
          ))}
        </Grid>

        {permission.map((perm: any, iPermission: any) => {
          const { name, view, add, edit, del, exp, menuFirstId, menuSecondId, menuThirdId, menuSecondKey, branchId } = perm;
          const isCheckApp = menuSecondKey === 'APPLICATION' ? handleCheckApp(branchId) : true;
          if (
            menuHidden.includes(name) ||
            !checkPackage(_.includes(PACKAGE_ADDONS, name) ? name : '') ||
            !isCheckApp ||
            name === 'TREATMENT'
          ) { return null; }

          const isSectionStart = menuFirstId && !menuSecondId && !menuThirdId;
          const labelPl = isSectionStart ? 0 : 2;
          const labelWeight = isSectionStart ? 500 : 400;

          return (
            <Box key={iPermission} component={Grid} container sx={{ pl: 3, py: 1 }}>
              {isSectionStart && iPermission !== 0 && (
                <Grid item xs={12}>
                  <Divider sx={{ mx: 0, my: 2, backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                </Grid>
              )}

              <Grid item xs={6} sm={2} sx={{ display: 'flex', alignItems: 'center' }} >
                <Typography sx={{ pl: labelPl, fontWeight: labelWeight }}>{t(`MENU.${name}`)}</Typography>
              </Grid>
              {[
                { key: 'view', checked: view, onChange: (e: any) => selectPermission(iRole, iServicePointSelect, name, 'view', e.target.checked, iPermission) },
                { key: 'add', checked: add, onChange: (e: any) => selectPermission(iRole, iServicePointSelect, name, 'add', e.target.checked, iPermission) },
                { key: 'edit', checked: edit, onChange: (e: any) => selectPermission(iRole, iServicePointSelect, name, 'edit', e.target.checked, iPermission) },
                { key: 'del', checked: del, onChange: (e: any) => selectPermission(iRole, iServicePointSelect, name, 'del', e.target.checked, iPermission) },
                { key: 'exp', checked: exp, onChange: (e: any) => selectPermission(iRole, iServicePointSelect, name, 'exp', e.target.checked, iPermission) },
              ].map(({ key, checked, onChange }) => (
                <Grid item xs={1} sm={2} key={key} sx={{ pl: { sm: 4 } }}>
                  <CheckboxButton checked={checked} onChange={onChange} />
                </Grid>
              ))}
            </Box>
          );
        })
        }
      </Box >
    )
  }

  return (
    <Box key={iRole} >
      <Grid container sx={{ mt: '1px', p: '8px', fontWeight: 600, fontSize: 18 }}>
        <Grid item xs={12}>
          <Box
            onClick={() => setOpenBranch(prev => !prev)}
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: '16px', py: '10px', cursor: 'pointer', fontSize: 18, fontWeight: 600, bgcolor: colors.themeSecondColor10, borderRadius: 1 }}>
            <Typography> {roles[iRole].branchName}
            </Typography>
            <Box sx={{ bgcolor: colors.white, p: 0.5, border: '1px solid gray', borderRadius: '30px', display: 'flex', alignItems: 'center', transition: 'transform 0.3s ease', transform: openBranch ? 'rotate(180deg)' : 'rotate(0deg)' }}>
              <KeyboardArrowDownIcon fontSize="small" />
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Collapse in={openBranch}>
        <Grid container sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', alignItems: 'center', overflowX: 'auto', whiteSpace: 'nowrap', borderBottom: `1px solid ${colors.extraLightBlue}`, mx: 2, width: 'calc(100% - 32px)', py: 0 }} >
              {roles[iRole].servicePointMenus.map(({ menuTag, permission }, iSP) => {
                const selected = iServicePointSelect === iSP;
                return (
                  <Box
                    key={iSP}
                    onClick={() => {
                      setDisplay((prev: any) => ({
                        ...prev,
                        [`{${iRole}_${iSP} } `]: !prev[`{${iRole}_${iSP} } `]
                      }));
                      setPermissonSelect(permission);
                      setIServicePointSelect(iSP);
                    }}
                    sx={{
                      display: 'inline-flex', alignItems: 'center', px: 3, py: 1.5, cursor: 'pointer', transition: 'all 0.3s ease-in-out', borderBottom: selected
                        ? `3px solid ${colors.themeSecondColor}`
                        : '3px solid transparent',
                      color: selected ? colors.themeSecondColor : 'inherit'
                    }}
                  >
                    <Typography variant="body2">{menuTag}</Typography>
                  </Box>
                );
              })}
            </Box>
          </Grid>
          {permissonSelect?.length > 0 && (
            <Grid item xs={12} sx={{ mt: 2 }}>
              {renderRole()}
            </Grid>
          )}
        </Grid>
      </Collapse>
    </Box>
  )
}
